import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateVendorContact } from '../../../state/vendorSlice';

const ZipEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentVendor } = useAppSelector(state => state.vendor);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateVendorContact({ zip: event.target.value }));
  };

  return (
    <TextField
      label="Zip"
      size="small"
      fullWidth
      value={currentVendor?.zip || ''}
      onChange={handleChange}
    />
  );
};

export default ZipEdit;
